import { createAction } from "@reduxjs/toolkit";

const SET_INVOICE =  "SET_INVOICE"
const RESET_INVOICE =  "RESET_INVOICE"

export const setInvoice = createAction<{
  field: FlattenKeys<InvoiceState>;
  value: any;
}>(SET_INVOICE);

export const resetInvoice = createAction<void>(RESET_INVOICE);

const invoiceActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setInvoice: <T extends FlattenKeys<InvoiceState>>(
        field: T,
        value: DeepType<InvoiceState, T>
      ) => dispatch<void>(setInvoice({ field, value })),
      resetInvoice: () => dispatch<void>(resetInvoice()),
    }
  );

export default invoiceActions;
